import { SwarmType } from '@/graphql/types';

function toTypenamePrefix(swarmType: SwarmType): string {
    return `${swarmType.charAt(0).toUpperCase()}${swarmType.slice(1)}`;
}

const SWARM_TYPE_TYPENAME_PREFIXES = Object.values(SwarmType).map((swarmType) => ({
    swarmType,
    prefix: toTypenamePrefix(swarmType),
}));

export function resolveSwarmTypeFromGraphqlTypename(
    typename: string | null | undefined
): SwarmType {
    if (typeof typename !== 'string' || typename.trim() === '') {
        throw new Error('Missing "__typename" while resolving swarm type.');
    }

    const resolvedSwarmType = SWARM_TYPE_TYPENAME_PREFIXES.find(({ prefix }) =>
        typename.startsWith(prefix)
    )?.swarmType;

    if (!resolvedSwarmType) {
        throw new Error(`Unsupported GraphQL typename "${typename}" for swarm type resolution.`);
    }

    return resolvedSwarmType;
}
